import { create } from "zustand";
import type { AuthUser } from "@kass/shared";
import type { PartnerAccess } from "../api/types";

type AuthState = {
  token: string | null;
  user: AuthUser | null;
  partners: PartnerAccess[];
  selectedPartnerId: string | null;
  setSession: (token: string, user: AuthUser) => void;
  setUser: (user: AuthUser) => void;
  setPartners: (partners: PartnerAccess[]) => void;
  setSelectedPartnerId: (partnerId: string) => void;
  clear: () => void;
};

export const useAuthStore = create<AuthState>((set) => ({
  token: null,
  user: null,
  partners: [],
  selectedPartnerId: null,
  setSession: (token, user) => set({ token, user }),
  setUser: (user) => set({ user }),
  setPartners: (partners) =>
    set((state) => ({
      partners,
      selectedPartnerId: partners.some((partner) => partner.id === state.selectedPartnerId)
        ? state.selectedPartnerId
        : partners[0]?.id ?? null
    })),
  setSelectedPartnerId: (partnerId) => set({ selectedPartnerId: partnerId }),
  clear: () => set({ token: null, user: null, partners: [], selectedPartnerId: null })
}));
